import config from "@Config/index";
import { nationalityForHomepage } from "@Pages/Search/components/SearchList/components/TrustPilotBanner/helper";

import type { TpReview } from "../../data/homeV3Reducer";

const REVIEW_COUNT = 12;

/** @deprecated Use `nationalityForHomepage(country)` — kept for imports that pass no country. */
export const REVIEW_NATIONALITY = nationalityForHomepage(null);

/** The review as the card shows it: on .cn, its Chinese edit when there is one. */
export const reviewText = (r: TpReview) =>
  (config.IS_CHINA_APP && (r.edited_review_zh as string)) || r.edited_review || "";

/**
 * Five-star reviews from named students with something to say, as the cards show.
 *
 * ⚠️  ONLY THE FIELDS THE CARDS SHOW are kept. The reviews API returns each reviewer's
 * email, booking and property details too, and these reviews are serialised into the
 * page's HTML (data/fetchHomeV3Data) — anything left on them is published to every
 * visitor and every crawler.
 */
const pickReviews = (data: TpReview[]): TpReview[] =>
  data
    .filter(
      (r) =>
        (r.trustpilot_rating ?? 5) >= 5 &&
        !!r.user_name &&
        r.user_name.trim().toLowerCase() !== "student" &&
        // Chinese says as much in far fewer characters
        reviewText(r).length >= (config.IS_CHINA_APP ? 12 : 60),
    )
    .slice(0, REVIEW_COUNT)
    .map(
      ({
        user_name,
        university,
        destination_city,
        trustpilot_rating,
        edited_review,
        edited_review_zh,
      }) => ({
        user_name,
        university,
        destination_city,
        trustpilot_rating,
        edited_review,
        ...(config.IS_CHINA_APP && edited_review_zh ? { edited_review_zh } : {}),
      }),
    );

export default pickReviews;
